import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArkikWebComponentsModule } from '@core/modules';
import { TranslationPipeModule } from '@shared/pipes/translation-pipe.module';
import { ArkikDialogModule } from '@shared/components/arkik-dialog/arkik-dialog.module';
import { ArkikOfflineAlertComponent } from './arkik-offline-alert.component';

/**
 * Programmatic component — used via ComponentPortal in PlantOfflineAlertService.
 * Not used in any template. Must be imported at app root level so Ivy compiles it.
 */
@NgModule({
  declarations: [ArkikOfflineAlertComponent],
  imports: [CommonModule, ArkikWebComponentsModule, TranslationPipeModule, ArkikDialogModule],
  exports: [ArkikOfflineAlertComponent],
})
export class OfflineAlertComponentModule {}
